import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import ProjectTodo from '@app/views/Project/Todo';
import { memo } from 'react';

export default memo(
  withIfUser(ProjectTodo)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
